import React from "react";
import { Slider } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";

const LightingSliderForm = ({ register, watch, setValue, preview = false, data = null }) => {
  // 1. Determine current values (default to 50 if undefined)
  const currentBacklight = preview 
    ? (data?.backlight ?? 50) 
    : (watch("formData.backlight") ?? 50);

  const currentAuxiliary = preview 
    ? (data?.auxiliary ?? 50) 
    : (watch("formData.auxiliary") ?? 50);

  // 2. Individual Change Handlers
  const handleBacklightChange = (event, newValue) => {
    if (!preview) setValue("formData.backlight", newValue);
  };

  const handleAuxiliaryChange = (event, newValue) => {
    if (!preview) setValue("formData.auxiliary", newValue);
  };

  // Reusable Slider Style
  const sliderStyles = {
    color: "info.main",
    height: 6,
    "& .MuiSlider-thumb": {
      width: 16,
      height: 16,
      backgroundColor: "#fff",
      border: "2px solid currentColor",
      "&:hover": {
        boxShadow: "0 0 0 8px rgba(25, 118, 210, 0.16)",
      },
    },
    "& .MuiSlider-track": { border: "none" },
    "& .MuiSlider-rail": { opacity: 0.5, backgroundColor: "#bfbfbf" },
  };

  return (
    <SoftBox 
      p={preview ? 1.5 : 2} 
      sx={{ 
        border: preview ? '1px solid #ddd' : '1px dashed #ccc', 
        borderRadius: '8px', 
        backgroundColor: '#fff',
      }}
    >
      {/* BACKLIGHT SLIDER */}
      <SoftBox mb={3}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <SoftTypography variant={preview ? "caption" : "body3"} fontWeight="bold" textTransform="uppercase">
            Backlight
          </SoftTypography>
          <SoftTypography variant="button" fontWeight="medium" color="info">
            {currentBacklight}%
          </SoftTypography>
        </SoftBox>
        <SoftBox px={1}>
          <Slider
            min={1}
            max={100}
            value={currentBacklight}
            onChange={handleBacklightChange}
            disabled={preview}
            sx={sliderStyles}
          />
        </SoftBox>
      </SoftBox>

      {/* AUXILIARY LIGHT SLIDER */}
      <SoftBox mb={0}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <SoftTypography variant={preview ? "caption" : "body3"} fontWeight="bold" textTransform="uppercase">
            Auxiliary Light
          </SoftTypography>
          <SoftTypography variant="button" fontWeight="medium" color="info">
            {currentAuxiliary}%
          </SoftTypography>
        </SoftBox>
        <SoftBox px={1}>
          <Slider
            min={1}
            max={100}
            value={currentAuxiliary}
            onChange={handleAuxiliaryChange}
            disabled={preview}
            sx={sliderStyles}
          />
        </SoftBox>
      </SoftBox>

      {/* Hidden inputs to register the fields with react-hook-form */}
      {!preview && (
        <>
          <input type="hidden" {...register("formData.backlight", { value: 50 })} />
          <input type="hidden" {...register("formData.auxiliary", { value: 50 })} />
        </>
      )}
    </SoftBox>
  );
};

export default LightingSliderForm;